import { render } from "./SoundtrackItem.vue?vue&type=template&id=aa869f30"
import script from "./SoundtrackItem.vue?vue&type=script&lang=js"
export * from "./SoundtrackItem.vue?vue&type=script&lang=js"

import "./SoundtrackItem.vue?vue&type=style&index=0&id=aa869f30&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__